import { useState } from 'react';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import type { WorkQueueCase, OutgoingAction } from '../../../services/workQueue';
import { PutOnHoldModal } from '../PutOnHoldModal';

interface RequestClarificationActionProps {
    workCase: WorkQueueCase;
    onTaskComplete?: (action?: OutgoingAction) => void;
}

// Shared Revisions-tab "Request clarification" affordance: identical button
// + PutOnHoldModal wiring for every design-loop phase (refinement, redesign, ...).
export function RequestClarificationAction({
    workCase: c,
    onTaskComplete
}: RequestClarificationActionProps) {
    const [open, setOpen] = useState(false);

    return (
        <>
            <button
                type="button"
                onClick={() => setOpen(true)}
                className="inline-flex items-center gap-1 px-2 py-[3px] rounded-md border border-gray-300 text-[11px] font-medium text-gray-500 bg-white hover:border-gray-400 hover:text-gray-900 transition-colors"
            >
                <QuestionMarkCircleIcon className="w-3 h-3" />
                Request clarification
            </button>
            {open && (
                <PutOnHoldModal
                    workCase={c}
                    onClose={() => setOpen(false)}
                    initialReason="clinical-question"
                    skipReasonStep
                    onTaskComplete={onTaskComplete}
                />
            )}
        </>
    );
}
